/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelCalculateTax.ts                  *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/dispatch/calculate-tax";

export class AutogenModelCalculateTax<RowType extends ModelRow> extends Endpoint<RowType, RowCalculateTaxFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowCalculateTax extends ModelRow<RowCalculateTaxFields> {
	constructor(values?: Partial<RowCalculateTaxFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowCalculateTaxFields {
	amount: number;
	amount_c: string;
	amount_d: Date;
	amount_n: number;
	amount_r: number;
	bill_type: string;
	company_id: string;
	customer_id: string;
	descr: string;
	excisetax_id: string;
	id: string;
	is_estimated: string;
	method: string;
	order_id: string;
	rate: number;
	state_id: string;
	tax_date: Date;
	units: number;
}

